import styled from 'styled-components';
import {
  Header as UnstyledHeader,
  HeaderWrapper as UnstyledHeaderWrapper,
} from '../../../../layouts/Header/styles';
import { LOGO_HEIGHT, responsiveHeight } from '../../../../layouts/Header/dimensions';

export const LanguageWrapper = styled.div`
  margin-left: auto;
`;

export const HeaderWrapper = styled(UnstyledHeaderWrapper)`
  ${({ theme }) =>
    theme.brand.headerBackgroundImage
      ? ''
      : 'background-image: none;'}

  ${UnstyledHeader} > img {
    ${responsiveHeight(LOGO_HEIGHT, h => `max-height: ${h}px;`)}
  }
`;
